import { render, staticRenderFns } from "./OmsHeader.vue?vue&type=template&id=b48d7a4a&scoped=true"
import script from "./OmsHeader.vue?vue&type=script&lang=js"
export * from "./OmsHeader.vue?vue&type=script&lang=js"
import style0 from "./OmsHeader.vue?vue&type=style&index=0&id=b48d7a4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d7a4a",
  null
  
)

export default component.exports